import BoxedLayout from "../../parts/layout/BoxedLayout";
import React, {useEffect, useState} from 'react';
import {Link, Navigate, useLocation} from 'react-router-dom';
import { FiCheckCircle, FiXCircle, FiDownload, FiMail } from 'react-icons/fi';
/*
interface TransactionData {
    authCode?: string;
    transactionDateUtc: string;
    cardHolderName?: string;
    transactionId?: string;
    status: string;
    totalAmount: string;
    approvedAmount: string;
    clientTransactionId?: string;
    tnsResponseCode?: string;
    tnsResponseText?: string;
    subtotalAmount?: string;
    surchargeAmount?: string;
    taxAmount?: string;
    requestId?: string;
    successful: boolean;
}*/

export default function CheckoutResult() {
    const location = useLocation();    
    const transactionData = location.state?.transactionData;
    const currency = location.state?.currency || 'USD';

    if (!transactionData) {
        return <Navigate to="/checkout" replace/>;
    }

    const isSuccess = transactionData.successful ?? false;

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        });
    };

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
            <div className="max-w-md w-full">
                {isSuccess ? (
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 text-center">
                        {/* Success Icon */}
                        <div className="mb-6">
                            <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
                                <FiCheckCircle className="w-8 h-8 text-green-600" />
                            </div>
                        </div>

                        {/* Success Message */}
                        <h1 className="text-2xl font-semibold text-gray-900 mb-2">Payment successful</h1>
                        <p className="text-gray-600 mb-8">
                            Thank you for your purchase! Your payment has been processed successfully.
                        </p>

                        {/* Payment Details */}
                        <div className="bg-gray-50 rounded-lg p-4 mb-6 text-left">
                            <div className="space-y-3">
                                <div className="flex justify-between">
                                    <span className="text-sm text-gray-600">Amount paid</span>
                                    <span className="text-sm font-medium text-gray-900">
                                        {new Intl.NumberFormat('en', { style: 'currency', currency }).format(transactionData.approvedAmount)}
                                    </span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-sm text-gray-600">Transaction ID</span>
                                    <span className="text-sm font-medium text-gray-900 text-right">{transactionData.transactionId || 'N/A'}</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-sm text-gray-600">Date</span>
                                    <span className="text-sm font-medium text-gray-900">{formatDate(transactionData.transactionDateUtc)}</span>
                                </div>
                                {transactionData.cardHolderName && (
                                    <div className="flex justify-between">
                                        <span className="text-sm text-gray-600">Cardholder</span>
                                        <span className="text-sm font-medium text-gray-900">{transactionData.cardHolderName}</span>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Action Buttons */}
                        <div className="space-y-3">
                            <button className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-3 px-4 rounded-full border border-gray-300 transition-colors flex items-center justify-center">
                                <FiDownload className="w-4 h-4 mr-2" />
                                Download receipt
                            </button>
                            <button className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-3 px-4 rounded-full border border-gray-300 transition-colors flex items-center justify-center">
                                <FiMail className="w-4 h-4 mr-2" />
                                Email receipt
                            </button>
                        </div>

                        {/* Return Link */}
                        <div className="mt-8 pt-6 border-t border-gray-200">
                            <Link 
                                to="/shoppingcart" 
                                className="text-blue-600 hover:text-blue-700 font-medium transition-colors"
                            >
                                ← Return to shop
                            </Link>
                        </div>
                    </div>
                ) : (
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 text-center">
                        {/* Error Icon */}
                        <div className="mb-6">
                            <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
                                <FiXCircle className="w-8 h-8 text-red-600" />
                            </div>
                        </div>

                        {/* Error Message */}
                        <h1 className="text-2xl font-semibold text-gray-900 mb-2">Payment failed</h1>
                        <p className="text-gray-600 mb-8">
                            We were unable to process your payment. Please try again or contact support.
                        </p>

                        {/* Error Details */}
                        {transactionData.tnsResponseText && (
                            <div className="bg-red-50 rounded-lg p-4 mb-6">
                                <p className="text-sm text-red-800">{transactionData.tnsResponseText}</p>
                            </div>
                        )}

                        {/* Action Buttons */}
                        <div className="space-y-3">
                            <Link 
                                to="/checkout" 
                                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-4 rounded-full transition-colors inline-block"
                            >
                                Try again
                            </Link>
                            <Link 
                                to="/shoppingcart" 
                                className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-3 px-4 rounded-full border border-gray-300 transition-colors inline-block"
                            >
                                Return to shop
                            </Link>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )

}